import { format, parseISO } from 'date-fns';

export const timeFormat = {
  data() {
    return {
      MX_timeFormat: 'HH:mm a',
    }
  },
  methods: {
    timeFormat (time) {
      if (time) {
        if (typeof time === 'string') {
          return format(parseISO(time), this.MX_timeFormat)
        }
        return format(time, this.MX_timeFormat);
      }
      
    }
  }
};

export const utcTimeFormat = {
  data() {
    return {
      MX_utcTimeFormat: "HH:mm '(UTC 'XXX')'",
    }
  },
  methods: {
    utcTimeFormat (time) {
      if (time) {
        if (typeof time === 'string') {
          return format(parseISO(time), this.MX_utcTimeFormat)
        }
        return format(time, this.MX_utcTimeFormat);
      }
      
    }
  }
};
